import type { CSSProperties } from 'react'
import { cn } from '@/lib/utils'
import { useReveal } from './useReveal'

export function SeatMeter({ seats, className }: { seats: number; className?: string }) {
  const ref = useReveal<HTMLDivElement>('seats')

  return (
    <div
      ref={ref}
      role="img"
      aria-label={`A batch has at most ${seats} seats`}
      className={cn('grid grid-cols-10 gap-2', className)}
    >
      {Array.from({ length: seats }, (_, index) => (
        <span
          key={index}
          className="seat aspect-square rounded-[6px] border border-[var(--color-brand-accent)]/35 bg-[linear-gradient(180deg,rgba(0,229,255,0.3),rgba(0,229,255,0.08))] shadow-[0_0_14px_-3px_rgba(0,229,255,0.45)]"
          style={{ '--seat-index': index } as CSSProperties}
        />
      ))}
    </div>
  )
}
